import React from "react";
import { Box, FormControlLabel, Switch, TextField, Typography } from "@mui/material";
import { PropertyGroup } from "../PropertyGroup";
import { useTreeModifyContext } from "../TreeDataContext";
import { usePathContext } from "../PathInfo";
import { parseIntWithinLimits } from "../Helpers";

export function MultiAndGapSizeSettings(props: { multi: boolean; gapSize?: number; maxSpread?: number }) {
  const { path } = usePathContext();
  const { saveChangesAtPath } = useTreeModifyContext();

  return (
    <PropertyGroup>
      <Box className="horizontal-flex flex-wrap">
        <Typography>Positions settings:&nbsp;</Typography>
        <FormControlLabel
          label="multi"
          control={
            <Switch
              checked={props.multi}
              onChange={(event, checked) => {
                saveChangesAtPath(checked, path.concat(["multi"]));
              }}
            />
          }
        />
        {props.multi && (
          <>
            <TextField
              size="small"
              id="max-spread"
              label="Max spread"
              variant="outlined"
              value={props.maxSpread}
              onChange={(event) => {
                saveChangesAtPath(parseIntWithinLimits(event.target.value), path.concat(["maxSpread"]));
              }}
            />
          </>
        )}
        {props.multi && (
          <>
            <TextField
              size="small"
              id="gap-size"
              label="Gap size"
              variant="outlined"
              value={props.gapSize}
              onChange={(event) => {
                saveChangesAtPath(parseIntWithinLimits(event.target.value), path.concat(["gapSize"]));
              }}
            />
          </>
        )}
      </Box>
    </PropertyGroup>
  );
}
